import { fg } from '@confluence/feature-gating';

import { useIsActionDisabledForWorkspace } from './useIsActionDisabledForWorkspace';

export const useShouldShowDSPWarningForWorkspace = (): boolean => {
	const isPublicLinksActionDisabled = useIsActionDisabledForWorkspace({
		action: 'PUBLIC_LINKS',
		skip: !fg('confluence_show_dsp_warning'),
	});
	const isAnonymousAccessActionDisabled = useIsActionDisabledForWorkspace({
		action: 'ANONYMOUS_ACCESS',
		skip: !fg('confluence_show_dsp_warning'),
	});
	return (
		(isPublicLinksActionDisabled || isAnonymousAccessActionDisabled) &&
		fg('confluence_show_dsp_warning')
	);
};
